import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import AsyncSelect from 'react-select/async';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { FaExchangeAlt } from 'react-icons/fa';
import PageCreateHeader from '../../components/PageCreateHeader';

const CreateRebalance = () => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const outletFromStorage = localStorage.getItem('id_outlet');
  const outletNameStorage = localStorage.getItem('outlet_name');
  const navigate = useNavigate();
  const [outletName, setOutletName] = useState('');
  const [type, setType] = useState('out');
  const [obat, setObat] = useState(null);
  const [outletId, setOutletId] = useState(role === 'manager' ? Number(outletFromStorage) : '');
  const [outletOptions, setOutletOptions] = useState([]);
  const [expiredOptions, setExpiredOptions] = useState([]);
  const [expiredId, setExpiredId] = useState('');
  const [stock, setStock] = useState('');
  const [message, setMessage] = useState('');
  const [objective, setObjective] = useState('');
  const [refId, setRefId] = useState('');
  const [evidence, setEvidence] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [distributorOptions, setDistributorOptions] = useState([]);
  const [useDistributor, setUseDistributor] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (['broken', 'expired', 'outlet'].includes(objective)) {
      setType('out');
    } else if (objective === 'rebalance') {
      setType('in');
    }
  }, [objective]);
useEffect(() => {
  if (role === 'manager' && outletFromStorage) {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/v1/outlet`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const outlet = res.data.data.find(o => Number(o.id) === Number(outletFromStorage));
        if (outlet) {
          setOutletName(outlet.name);
        }
      })
      .catch((err) => console.error('Gagal mendapatkan nama outlet manager:', err));
  }
}, [role, outletFromStorage, token]);

  useEffect(() => {
    if (role !== 'manager') {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/v1/outlet`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          const options = res.data.data.map((o) => ({
            value: o.id,
            label: o.name,
          }));
          setOutletOptions(options);
        })
        .catch((err) => console.error('Gagal load outlet:', err));
    }
  }, [token, role]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/v1/distributor`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.map((d) => ({
          value: d.id,
          label: d.name,
        }));
        setDistributorOptions(data);
      })
      .catch((err) => console.error(err));
  }, [token]);

  useEffect(() => {
    if (!obat || !outletId) return;

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/v1/drug/stock/${obat.value}/${outletId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.map((item) => ({
          value: item.id,
          label: `${new Date(item.expired_at).toLocaleDateString()} - Stock: ${item.stock}`,
          stock: item.stock,
        }));
        setExpiredOptions(data);
      })
      .catch((err) => console.error('Gagal load expired_id:', err));
  }, [obat, outletId, token]);

  const loadObatOptions = async (inputValue) => {
    if (!outletId) return [];

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/drug?id_outlet=${outletId}&search=${inputValue}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return res.data.data.map((obat) => ({
        value: obat.id,
        label: obat.name,
      }));
    } catch (err) {
      console.error('Error fetching obat:', err);
      return [];
    }
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (!file) return;
    readFile(file);
  };

  const readFile = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setEvidence(reader.result);
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const confirm = window.confirm('Yakin ingin mengirim rebalance ini?');
    if (!confirm) return;

    const payload = {
      type,
      obat_id: obat?.value,
      outlet_id: Number(outletId),
      expired_id: Number(expiredId),
      stock: parseInt(stock),
      message,
      objective,
      ref_id: Number(refId) || 0,
      evidence,
    };

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/rebalance`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('✅ Rebalance berhasil dibuat!');
      resetForm();
      navigate('/rebalance');
    } catch (err) {
      console.error(err);
      toast.error('❌ Gagal membuat rebalance');
    }
  };

  const resetForm = () => {
    setObat(null);
    setOutletId(role === 'manager' ? Number(outletFromStorage) : '');
    setExpiredId('');
    setStock('');
    setMessage('');
    setObjective('');
    setRefId('');
    setEvidence('');
    setPreviewUrl('');
    setUseDistributor(false);
  };

  return (
    <div className="min-h-screen flex flex-col space-y-6 w-full min-w-0 px-4 pb-10">
      <ToastContainer />
      <PageCreateHeader
        icon={FaExchangeAlt}
        title={`Buat Rebalance (${type === 'in' ? 'In' : 'Out'})`}
        description="Catat penyesuaian stok masuk atau keluar sesuai tujuan"
        breadcrumbs={[
          { label: 'Enterprise', to: '/' },
          { label: 'Rebalance', to: '/rebalance' },
          { label: `Buat (${type === 'in' ? 'In' : 'Out'})` },
        ]}
      />

    <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 w-full">
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 gap-6">
          {/* KIRI */}
          <div className="space-y-4">
            {/* Outlet */}
            <div>
              <label className="block text-gray-600 font-semibold mb-1">Outlet</label>
              {role === 'manager' ? (
                <input
                  type="text"
                  value={outletName || `Outlet ID ${outletId}`}
                  className="w-full p-2 border rounded-lg bg-gray-100 text-gray-600"
                  disabled
                />
              ) : (
                <select
                  className="w-full p-2 border rounded-lg"
                  value={outletId}
                  onChange={(e) => setOutletId(Number(e.target.value))}
                >
                  <option value="">Pilih outlet</option>
                  {outletOptions.map((o) => (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </select>
              )}
            </div>

            {/* Obat */}
            <div>
              <label className="block text-gray-600 font-semibold mb-1">Obat</label>
              <AsyncSelect
                cacheOptions
                defaultOptions
                loadOptions={loadObatOptions}
                onChange={setObat}
                placeholder="Cari obat..."
                value={obat}
                isDisabled={!outletId}
              />
            </div>

            {/* Expired */}
            <div>
              <label className="block text-gray-600 font-semibold mb-1">Expired</label>
              <select
                className="w-full p-2 border rounded-lg"
                value={expiredId}
                onChange={(e) => {
                  const selected = expiredOptions.find((ex) => ex.value === Number(e.target.value));
                  setExpiredId(Number(e.target.value));
                  if (selected?.stock !== undefined) {
                    setStock(selected.stock.toString());
                  }
                }}
              >
                <option value="">Pilih expired</option>
                {expiredOptions.map((ex) => (
                  <option key={ex.value} value={ex.value}>
                    {ex.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Stock */}
            <div>
              <label className="block text-gray-600 font-semibold mb-1">Jumlah Stock</label>
              <input
                type="number"
                value={stock}
                onChange={(e) => setStock(e.target.value)}
                className="w-full p-2 border rounded-lg"
                placeholder="Masukkan stock"
              />
            </div>
          </div>

          {/* KANAN */}
          <div className="space-y-4">
            {/* Objective */}
            <div>
              <label className="block text-gray-600 font-semibold mb-1">Objective</label>
              <select
                className="w-full p-2 border rounded-lg"
                value={objective}
                onChange={(e) => setObjective(e.target.value)}
              >
                <option value="">Pilih tujuan</option>
                <option value="broken">Broken</option>
                <option value="rebalance">Rebalance</option>
                <option value="expired">Expired</option>
                <option value="outlet">Outlet</option>
              </select>
            </div>

            {/* Ref ID */}
           <div>
  <label className="flex items-center gap-2 text-gray-600 font-semibold mb-1">
    <input
      type="checkbox"
      checked={useDistributor}
      onChange={(e) => {
        setUseDistributor(e.target.checked);
        if (!e.target.checked) setRefId('');
      }}
    />
    Gunakan Distributor
  </label>

  <select
    className="w-full p-2 border rounded-lg"
    value={refId}
    onChange={(e) => setRefId(Number(e.target.value))}
    disabled={!useDistributor}
  >
    <option value="">Pilih distributor</option>
    {distributorOptions.map((d) => (
      <option key={d.value} value={d.value}>
        {d.label}
      </option>
    ))}
  </select>
</div>

            {objective === 'outlet' && (
              <div>
                <label className="block text-gray-600 font-semibold mb-1">Outlet Tujuan</label>
                <select
                  className="w-full p-2 border rounded-lg"
                  value={refId}
                  onChange={(e) => setRefId(Number(e.target.value))}
                >
                  <option value="">Pilih outlet tujuan</option>
                  {outletOptions
                    .filter((o) =>
                      outletId ? Number(o.value) !== Number(outletId) : true
                    )
                    .map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                </select>
              </div>
            )}

            {/* Message */}
            <div>
              <label className="block text-gray-600 font-semibold mb-1">Pesan</label>
              <textarea
                className="w-full p-2 border rounded-lg"
                rows={3}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Contoh: Broken dari Outlet A ke Outlet B"
              ></textarea>
            </div>

            {/* Evidence Upload */}
            <div
              onDrop={handleFileDrop}
              onDragOver={(e) => e.preventDefault()}
              className="w-full p-4 border-2 border-dashed rounded-lg text-center text-gray-500 hover:border-blue-400 cursor-pointer bg-gray-50"
              onClick={() => fileInputRef.current.click()}
            >
              <p>Seret & jatuhkan gambar di sini, atau klik untuk pilih</p>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) readFile(file);
                }}
                hidden
              />
            </div>

            {previewUrl && (
              <div className="mt-3">
                <p className="text-sm text-gray-600 mb-1">Preview:</p>
                <img src={previewUrl} alt="Preview Evidence" className="w-full rounded border" />
              </div>
            )}
          </div>
        </div>

        <button
          type="submit"
          className="mt-6 w-full py-3 bg-green-600 text-white rounded-full font-semibold hover:bg-green-700 transition"
        >
          Submit
        </button>
      </form>
    </div>
    </div>
  );
};

export default CreateRebalance;
